import { useAtomValue } from 'jotai';

import { $scaleTicketTouchMode } from '~/modules/trade/_state/scaleTicketSettings.state';

export const useUIPreferences = () => {
  const touchModeEnabled = useAtomValue($scaleTicketTouchMode);

  return {
    touchModeEnabled,
  };
};
